import React from "react";
import { Navigate } from "react-router-dom";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { useAuth } from "../../contexts/AuthContext";
import MaterialList from "../Materials/MaterialList";
import AgentList from "../Agents/AgentList";
import adsSectionImage from "../../assets/imgs/ads-section.png";
import playStoreIcon from "../../assets/imgs/playstore.png";
import appStoreIcon from "../../assets/imgs/apple.png";

const PublicLanding = () => {
  const { user } = useAuth();
  const playStoreLink = "https://play.google.com/store/apps/details?id=com.jhonks.jhonksmobile";
  const appStoreLink = "https://www.apple.com/app-store/";
  // If already logged in, redirect to the dashboard.
  if (user) return <Navigate to="/" />;

  return (
    <div className="space-y-8">
      <MaterialList />
      <section className="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
          <div className="p-6 md:p-10">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
              Jhonks is wherever you are! Need an Agent?
            </h2>
            <p className="mt-3 text-gray-600 leading-relaxed">
              Download the Jhonks app or right here on your browser to Locate the nearest agent to you.
            </p>

            <div className="mt-6 space-y-3">
              {[
                "Join over 1 million Jhonks Sellers",
                "Join over 2k Jhonks Agent",
                "Join over 50 Industries using Jhonks",
              ].map((item) => (
                <div key={item} className="flex items-center gap-3">
                  <CheckCircleIcon className="h-5 w-5 text-green-600 flex-shrink-0" />
                  <span className="text-gray-700 text-sm md:text-base">{item}</span>
                </div>
              ))}
            </div>

            <div className="mt-7 flex flex-wrap gap-3">
              <a
                href={playStoreLink}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 rounded-lg bg-green-600 px-4 py-2.5 text-white font-semibold hover:bg-green-700 transition-colors"
              >
                <img src={playStoreIcon} alt="Google Play" className="h-5 w-5 object-contain" />
                Get it on Google Play
              </a>
              <a
                href={appStoreLink}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 rounded-lg bg-gray-900 px-4 py-2.5 text-white font-semibold hover:bg-black transition-colors"
              >
                <img src={appStoreIcon} alt="App Store" className="h-5 w-5 object-contain" />
                Download on the App Store
              </a>
            </div>
          </div>

          <div className="bg-gray-50">
            <img
              src={adsSectionImage}
              alt="Jhonks app download"
              className="w-full h-full object-cover min-h-[280px]"
            />
          </div>
        </div>
      </section>
      <AgentList hideBecomeAgentCta />
    </div>
  );
};

export default PublicLanding;

